import { render, staticRenderFns } from "./coderProjectList.vue?vue&type=template&id=66300954&scoped=true&"
import script from "./coderProjectList.vue?vue&type=script&lang=js&"
export * from "./coderProjectList.vue?vue&type=script&lang=js&"
import style0 from "./coderProjectList.vue?vue&type=style&index=0&id=66300954&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66300954",
  null
  
)

export default component.exports